import * as React from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { GDSHeadingLevel } from '@leagueplatform/genesis-core';
import { CHAT_HISTORY_MODULE_ASSET_KEYS } from '../../../asset-map';
import { MessageState } from '../../../components/message-state/message-state.component';

export const NODE_TYPE_CHAT_HISTORY_EMPTY_STATE = 'chatHistoryEmptyState';

type ChatHistoryEmptyStateProps = {
  heading: string;
  headingLevel?: GDSHeadingLevel;
  description?: string;
  image?: {
    source: string;
    description: string;
  };
};

type ChatHistoryEmptyStateNode = MasonryEngineNode<
  typeof NODE_TYPE_CHAT_HISTORY_EMPTY_STATE,
  ChatHistoryEmptyStateProps
>;

export type ChatHistoryEmptyStateRendererProps =
  MasonryEngineNodeRendererProps<ChatHistoryEmptyStateNode>;

export const ChatHistoryEmptyStateRenderer = ({
  heading,
  headingLevel,
  description,
  image,
}: ChatHistoryEmptyStateRendererProps): React.ReactElement => {
  const defaultImage = useStaticAsset(
    CHAT_HISTORY_MODULE_ASSET_KEYS.EMPTY_STATE,
  ) as string;

  return (
    <MessageState
      image={image?.source ?? defaultImage}
      imageAlt={image?.description ?? ''}
      heading={heading}
      headingLevel={headingLevel}
      description={description}
    />
  );
};
